<template>
  <section>
    <div class="settings-header">
      {{ __('Campos Customizados') }}
      <button
        class="btn btn-primary ml-auto"
        @click.prevent="openModal()"
      >
        {{ __('Adicionar campo') }}
      </button>
    </div>
    <div class="row">
      <div class="col-12">
        <p class="form-text">
          {{ __('Defina campos personalizados para seus leads.') }}
        </p>
        <p class="form-text">
          {{ __('Eles aparecerão como opção nos formulários e podem também ser enviados via API') }}.
        </p>
        <div class="row">
          <div
            class="col-12"
            v-if="loading"
          >
            <i class="fa fa-circle-o-notch fa-spin mt-4" />
          </div>
          <div
            class="col-12"
            v-else
          >
            <ul class="settings-group list-group mt-4">
              <li
                class="list-group-item d-flex align-items-center"
                v-for="(field, key) in fields"
                :key="key"
              >
                <strong>{{ field.description }}</strong><i class="fa fa-angle-right mx-2" /><span class="mr-3">{{ field.identifier }}</span><span
                  class="ml-auto mt-n1px"
                  v-if="field.type !== 'core'"
                ><a
                  class="ml-3"
                  href="#"
                  v-b-tooltip.left="__('Editar campo personalizado')"
                  @click.prevent="edit(field)"
                >
                  <IconPencilFilled :size="18" /></a><a
                  class="ml-3"
                  href="#"
                  v-b-tooltip.left="__('Excluir campo personalizado')"
                  @click.prevent="destroy(field)"
                >
                  <IconTrash :size="18" /></a></span>
              </li>
            </ul>
          </div>
        </div>
        <TenantCustomFieldModal
          :open="showModal"
          @close="closeModal"
        />
      </div>
    </div>
  </section>
</template>

<script>
import { VBTooltip } from 'bootstrap-vue';
import Swal from 'sweetalert2';

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },

  mounted () {
    this.getFields();
  },

  data () {
    return {
      loading: false,
      showModal: false,
      fields: [],
    };
  },

  methods: {
    getFields () {
      this.loading = true;

      this.$http.get('/settings/field?all=true')
        .then(({ data: fields }) => {
          this.fields = fields.filter((field) => field.type !== 'core');
        })
        .catch(() => {
          Alert.error(this.__('Erro ao listar campos'));
        })
        .finally(() => {
          this.loading = false;
        });
    },

    edit (field) {
      this.openModal({ field: { ...field } });
    },

    async destroy (field) {
      if (! await this.showConfirmationAlert(field.description)) {
        return;
      }

      this.loading = true;

      this.$http.delete(`/settings/field/${field.id}`)
        .then(() => {
          this.fields.splice(this.fields.indexOf(field), 1);

          Alert.success(this.__('Campo excluido com sucesso'));
        })
        .catch(({ body: { error } }) => {
          Alert.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    async showConfirmationAlert (fieldDescription) {
      const confirm = await Swal.fire({
        icon: null,
        title: this.__('Excluir campo'),
        html: `
          <div class="delete-custom-field-confirmation-alert-content">
            <div class="field-info">
              <span>${this.__('Campo customizado')}:</span> <strong>${fieldDescription}</strong>
            </div>
            <div class="warning">
              <h5>${this.__('Deseja realmente excluir este campo?')}</h5>
              <div class="warning-box">
                <div>
                  <img src="/build/icons/exclamation-warning.svg" />
                </div>
                <div>
                  ${this.__('Excluir um campo customizado não afeta segmentações ou integrações existentes. Você deve remover o campo de qualquer formulário antes de prosseguir.')}
                </div>
              </div>
            </div>
          </div>
        `,
        buttonsStyling: false,
        allowEscapeKey: false,
        allowOutsideClick: false,
        confirmButtonColor: 'transparent',
        confirmButtonText: this.__('Continuar'),
        cancelButtonColor: 'transparent',
        cancelButtonText: this.__('Cancelar'),
        showCancelButton: true,
        showCloseButton: true,
        customClass: {
          container: 'container-swal2 delete-custom-field-confirmation-alert',
          confirmButton: 'salesflow-btn salesflow-btn-secondary',
          cancelButton: 'btn swal2-btn-cancel-transparent swal2-btn-full-line',
        },
      });

      return confirm.value === true;
    },

    openModal (param = true) {
      this.showModal = param;
    },

    closeModal (params) {
      if (params.stored || params.updated) {
        this.getFields();
      }

      this.showModal = false;
    },
  },
};
</script>
